import { defineComponent as _defineComponent } from 'vue'
import {  watchEffect, ref, watch, defineProps, computed, nextTick, defineEmits } from "../../../../adapter-vue";
import { handleSkeletonSize } from '../../utils/utils';
import { TUIGlobal } from "@tencentcloud/chat-uikit-engine";

export default /*#__PURE__*/_defineComponent({
  __name: 'message-image',
  props: {
  content: {
    type: Object,
    default: () => ({}),
  },
  isPC: {
    type: Boolean,
    default: false,
  },
  messageItem: {
    type: Object,
    default: () => ({}),
  }
},
  emits: ["uploading", "previewImage"],
  setup(__props, { emit: emits }) {

const props = __props



const data = ref({
  progress: 0
});
const message = ref();
const show = ref();
const skeleton: any = ref();
  
const isH5 = ref(TUIGlobal.getPlatform() === "h5");
const messageStatus = ref(props.messageItem.status);

const isWidth = computed(() => {
  const { width = 0, height = 0 } = props.messageItem.payload.imageInfoArray[0];
  return width >= height;
});

watchEffect(() => {
  data.value = props.content;
  message.value  = props.messageItem;
  if (!data.value) return;
  nextTick(() => {
    if (!data.value.progress && messageStatus.value === 'success') {
      const { width = 0, height = 0 } = data.value;
      if (width === 0 || height === 0) return;
      const containerWidth = document.getElementById('app')?.clientWidth || 0;
      const max = !props.isPC ? Math.min(containerWidth - 180, 300) : 300;
      const size = handleSkeletonSize(width, height, max, max);
      skeleton?.value?.style && (skeleton.value.style.width = `${size.width}px`);
      skeleton?.value?.style && (skeleton.value.style.height = `${size.height}px`);
    } else {
      emits('uploading');
    }
  });
});

const toggleShow = () => {
  if (!data.value.progress) {
    // emits('previewImage', (data.value any).message);
  }
};
const downloadImage = (message: any) => {
  const targetImage = document.createElement('a');
  const downloadImageName = message.payload.imageInfoArray[0].instanceID;
  targetImage.setAttribute('download', downloadImageName);
  const image = new Image();
  image.src = message.payload.imageInfoArray[0].url;
  image.setAttribute('crossOrigin', 'Anonymous');
  image.onload = () => {
    targetImage.href = getImageDataURL(image);
    targetImage.click();
  };
};

const getImageDataURL = (image: any) => {
  const canvas = document.createElement('canvas');
  canvas.width = image.width;
  canvas.height = image.height;
  const ctx = canvas.getContext('2d');
  ctx?.drawImage(image, 0, 0, image.width, image.height);
  const extension = image.src.substring(image.src.lastIndexOf('.') + 1).toLowerCase();
  return canvas.toDataURL(`image/${extension}`, 1);
};

watch(
  () => props.messageItem.status,
  (newVal: any, oldVal: any) => {
    messageStatus.value = newVal;
    if (newVal === "success" && oldVal !== "success") {
      emits("uploading");
    }
  }
);

return { __sfc: true,props, data, message, show, skeleton, emits, isH5, messageStatus, isWidth, toggleShow, downloadImage, getImageDataURL }
}

})